import { BaseComponentRegistry } from "@/Common/Modularity/BaseComponentRegistry";
import { createRegistryListView } from "@/Common/Modularity/Components/ComponentRegistryWrapper";

enum CustomClassComponentId {
    OntarioMdHealthReportManager_CustomClass = 0
}

/**
 * Props passed to each registered left-side component.
 * Extend as needed when more context is required by extensions.
 */
interface ICustomClassComponentRegistryProps {
}

/**
 * Registry responsible for rendering additional components next to the title
 * in the DocumentSearch header (`additionalLeftComponent`).
 */
class CustomClassComponentRegistry extends BaseComponentRegistry<CustomClassComponentId, ICustomClassComponentRegistryProps> {}

/**
 * React view that renders all registered left-side header components.
 * HRM_CLEANUP: Delete this view when Ontario MD certification is complete.
 */
const CustomClassComponentRegistryView = createRegistryListView(() => CustomClassComponentRegistry.getInstance());

export {
    CustomClassComponentId,
    CustomClassComponentRegistry,
    CustomClassComponentRegistryView,
    ICustomClassComponentRegistryProps
};
